/**
 * Example use of this JS event:
 *
 * window.addEventListener('breakpointChange', (e) => {
 *	if (e.detail.isMobile) {
 *		// Do Mobile stuff until breakpoint has changed
 *	} else {
 *		// Do Desktop stuff until breakpoint has changed
 *	}
 * });
 */

document.addEventListener('DOMContentLoaded', () => {
	let styles = getComputedStyle(document.documentElement);
	const mediaQuery = window.matchMedia(`(max-width:${styles.getPropertyValue('--breakpoint-md')})`);
	let lastState = mediaQuery.matches;

	function dispatchBreakpointChangeEvent(isMobile) {
		const event = new CustomEvent('breakpointChange', {
			detail: {
				isMobile,
			},
		});
		window.dispatchEvent(event);
	}

	// Fire the initial custom event
	dispatchBreakpointChangeEvent(lastState);

	function onMediaQueryChange(e) {
		if (e.matches !== lastState) {
			lastState = e.matches;
			dispatchBreakpointChangeEvent(lastState);
		}
	}

	mediaQuery.addEventListener('change', onMediaQueryChange);
});
